<template>
  <div class="flex items-center text-gold">
    <IconSuccess class="size-8 pr-3" />
    <slot></slot>
  </div>
</template>

<script>
export default defineComponent({
  name: 'Success',
})
</script>
